export const AW_MODEL_MANAGEMENT_API_URL = process.env?.AWAPI_AWMODELMANAGEMENT_URL || '/api/wealth/model-management';
